import { render } from "./ImpressionsChart.vue?vue&type=template&id=b2f32e36&ts=true"
import script from "./ImpressionsChart.vue?vue&type=script&lang=ts"
export * from "./ImpressionsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__